module.exports = __webpack_public_path__ + "static/img/AU.3ff869c3.png";